import React, { useEffect, useState } from 'react';
import ProfileBanner from './Banner';
// import ProfileIntro from './ProfileIntro';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Education from './Education';
import Certification from './Certification';
import CalendarManagement from '../calendar/CalendarManagement';
import WorkExperience from '../other/WorkExperience';
import { getNurseDetails, updateDetails } from 'nursd-dashboard/api/nurseTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  getAllFacilityOrgList,
  getCalenderDataNurse
} from 'nursd-dashboard/api/organizationTable';
import { socket } from 'nursd-dashboard/api/socket';
import { toast } from 'react-toastify';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { getCustomerTableList } from 'nursd-dashboard/api/customerTable';

const TabOne = ({ nurseId }) => {
  const { authToken, location, organization } = useAuth();
  const [user, setUser] = useState(null);
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [managers, setManagers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const checkUser = async (authToken, id) => {
    try {
      await getNurseDetails(authToken, id).then(res => {
        if (res === undefined) {
          setUser(null);
          setLoading(false);
        } else {
          setUser(res);
          setLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getManager = async () => {
    try {
      const cusList = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          value: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          facilityLoginControl: item?.facilityLoginControl
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setManagers(array);
      }
    } catch (error) {
      setManagers([]);
    }
  };

  const getCustomer = async () => {
    try {
      const cusList = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          value: item.id,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          avatar: {
            name: item.firstName + ' ' + item.lastName
          },
          email: item.email,
          address: item.fullAddress,
          latitude: item.latitude,
          longitude: item.longitude,
          phone: item.phoneOne,
          status: item?.active,
          joined: item.createdAt,
          original: item
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setCustomers(array);
      }
    } catch (error) {
      setCustomers([]);
    }
  };

  useEffect(() => {
    if (nurseId !== null) {
      checkUser(authToken, nurseId);
      getCalender(authToken, nurseId);
      getManager();
      getCustomer();
    }
  }, [nurseId, refresh]);

  const getCalender = async (authToken, id) => {
    setLoading(true);
    await getCalenderDataNurse(authToken, id)
      .then(res => {
        setCalendarData(res);
      })
      .catch(e => console.log(e));
  };

  const updateUser = async (id, data, name, value) => {
    await updateDetails(authToken, id, data);
    socket?.emit('activateDeactivate', {
      table: 'NurseTable',
      id: id
    });
    if (value === 'Deactivate') {
      toast.error(`${name} has been ${value}d successfully.`, {
        theme: 'colored'
      });
    } else {
      toast.success(`${name} has been ${value}d successfully.`, {
        theme: 'colored'
      });
    }
    getAllFacilityOrgList(authToken, location, organization)
      .then(async facilitiesData => {
        for (const facility of facilitiesData) {
          try {
            await postFacilityNotification(
              authToken,
              facility?.id,
              '',
              `${name} has been ${value}d`,
              `${name} has been ${value}d by Admin.`,
              'ManageUser',
              {
                id: ''
              },
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableNotificationInsert', {
              table: 'FacilityNotificationTable',
              id: facility?.id
            });
            socket?.emit('activateDeactivate', {
              table: 'NurseTable',
              id: id
            });
            if (facility?.mobileId) {
              sendNotification(authToken, {
                expoPushToken: facility?.mobileId,
                title: `${name} has been ${value}d`,
                body: `${name} has been ${value}d by Admin.`,
                data: { screen: 'NotificationScreen' }
              });
            }
            checkUser(authToken, nurseId);
          } catch (error) {
            console.error('Error fetching facility detail:', error);
          }
        }
      })
      .catch(error => console.error('Fetching facility:', error));
  };

  const updateUserSuspend = async (id, data, name, value) => {
    await updateDetails(authToken, id, data);
    socket?.emit('activateDeactivate', {
      table: 'NurseTable',
      id: id
    });
    if (value === 'Suspend') {
      toast.error(`${name} has been ${value}ed successfully.`, {
        theme: 'colored'
      });
    } else {
      toast.success(`${name} has been ${value}ed successfully.`, {
        theme: 'colored'
      });
    }
    getAllFacilityOrgList(authToken, location, organization)
      .then(async facilitiesData => {
        for (const facility of facilitiesData) {
          try {
            await postFacilityNotification(
              authToken,
              facility?.id,
              '',
              `${name} has been ${value}ed`,
              `${name} has been ${value}ed by Admin.`,
              'ManageUser',
              {
                id: ''
              },
              false,
              false,
              'green',
              ''
            );
            socket?.emit('tableNotificationInsert', {
              table: 'FacilityNotificationTable',
              id: facility?.id
            });
            socket?.emit('activateDeactivate', {
              table: 'NurseTable',
              id: id
            });
            if (facility?.mobileId) {
              // if (Platform.OS !== 'web') {
              //   sendPushNotificationActivate({
              //     expoPushToken: facility?.mobileId,
              //     job: `${name} has been ${value}ed`,
              //     name: name,
              //     typeMessage: `${name} has been ${value}ed by Admin.`,
              //     jobId: ''
              //   });
              // }
            }
            checkUser(authToken, nurseId);
          } catch (error) {
            console.error('Error fetching facility detail:', error);
          }
        }
      })
      .catch(error => console.error('Fetching facility:', error));
  };

  // console.log(user?.profileImage);
  return (
    <>
      {loading ? (
        <p className="mt-2">Loading...</p>
      ) : (
        <div>
          <ProfileBanner
            user={user}
            updateUser={updateUser}
            updateUserSuspend={updateUserSuspend}
          />

          <Row className="g-3 mb-3">
            <Col lg={4}>
              <Card>
                <Card.Header className="border-bottom">
                  <h6 className="mb-0 fs-9">Specialty</h6>
                </Card.Header>
                <Card.Body>
                  <div
                    id="terms-sidebar"
                    className="terms-sidebar nav flex-column fs-10"
                  >
                    {user?.specialty?.map((item, index) => {
                      return (
                        <p key={index} className="px-0 py-1">
                          {item}
                        </p>
                      );
                    })}
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card>
                <Card.Header className="border-bottom">
                  <h6 className="mb-0 fs-9">Skills</h6>
                </Card.Header>
                <Card.Body>
                  <div
                    id="terms-sidebar"
                    className="terms-sidebar nav flex-column fs-10"
                  >
                    {user?.EMRorEHRExperience?.map((item, index) => {
                      return (
                        <p key={index} className="px-0 py-1">
                          {item}
                        </p>
                      );
                    })}
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card>
                <Card.Header className="border-bottom">
                  <h6 className="mb-0 fs-9">EMR / EHR Experience</h6>
                </Card.Header>
                <Card.Body>
                  <div
                    id="terms-sidebar"
                    className="terms-sidebar nav flex-column fs-10"
                  >
                    {user?.skills?.map((item, index) => {
                      return (
                        <p key={index} className="px-0 py-1">
                          {item}
                        </p>
                      );
                    })}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col lg={12}>
              <CalendarManagement
                data={calendarData}
                nurse={user}
                managers={managers}
                customers={customers}
                refresh={refresh}
                setRefresh={setRefresh}
              />
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col lg={4}>
              <Education data={user?.educationDetails} />
            </Col>
            <Col lg={4}>
              <Certification data={user?.certificationDetails} />
            </Col>
            <Col lg={4}>
              <WorkExperience data={user?.workExperienceDetails} />
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

TabOne.propTypes = {
  nurseId: PropTypes.number
};

export default TabOne;
